import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ngcFilterListByAttribute'
})
export class NgcFilterListByAttributePipe implements PipeTransform {

    transform<T>(list: T[], attribute: string, opposite = false): T[] {
        return list.filter((item: T) =>
            typeof item === 'object' && item !== null && item.hasOwnProperty(attribute)
            && (opposite ? !item[attribute] : item[attribute])
        );
    }
}
